import { colors } from '@mui/material/';

const _customObj = {
  root: {
    backgroundColor: colors.grey[50]
  }
};

export default _customObj;